import { useEffect, useRef, useState } from 'react'

export const useNavigationDisableOverlappingEvents = () => {
  const [disableEvent, setDisableEvent] = useState(false)
  const targetRef = useRef<(HTMLButtonElement | null)[]>([])

  useEffect(() => {
    const observerCallback = (mutationsList: MutationRecord[]) => {
      for (const mutation of mutationsList) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'data-state' &&
          (mutation.target as HTMLButtonElement).dataset.state === 'open'
        ) {
          setDisableEvent(true)
          const timeout = setTimeout(() => {
            setDisableEvent(false)
            clearTimeout(timeout)
          }, 1000)
        }
      }
    }

    const observer = new MutationObserver(observerCallback)

    for (const element of targetRef.current) {
      if (element) {
        observer.observe(element, {
          attributes: true,
        })
      }
    }

    return () => {
      observer.disconnect()
    }
  }, [])

  return { disableEvent, targetRef }
}
